/* eslint-disable arrow-parens */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable no-eval */
/* eslint-disable @typescript-eslint/naming-convention */
import { Inject, Injectable } from '@angular/core';
import {
    AbstractControl,
    FormControl,
    FormGroup,
    ValidationErrors,
    ValidatorFn,
    Validators,
} from '@angular/forms';
import { APP_PATH, LAYOUT_ITEM_TYPE } from '@app/modules/common/enum-constant';
import {
    AndOrLogic,
    AppData,
    AppDataSetParam,
    BodyItem,
    DoLogic,
    ElseLogic,
    GroupLogic,
    GroupLogicObject,
    IfConditionLogic,
    IfLogic,
    InfoFormData,
    QuizResult,
    Survey,
    SurveyHandledData,
    UnknowObject,
} from '@app/modules/common/survey-force-model';
import { BehaviorSubject, Observable, Subject, take } from 'rxjs';
import Cookies from 'js-cookie';
import { DOCUMENT } from '@angular/common';
import { Params, Router } from '@angular/router';
import { FuseLoadingService } from '@fuse/services/loading';
import { CustomLoadingService } from '@app/modules/components/loading/loading.service';
import { environment } from '@environment/environment';
import {
    InitMiniApp,
    checkAppOpenedOnMiniApp,
} from '@onemount/mini-app-module';
import { initializeApp } from '@onemount/mtp-tracking-sdk';

/**
 * Safely parse a query-param/flag value into a boolean without using eval().
 * Any untrusted value (e.g. from location.search) is treated as inert data:
 * only the literal string 'true' (case-insensitive) or the boolean `true`
 * is considered truthy. Everything else resolves to `false`.
 * This prevents DOM-based XSS via crafted query parameters (CWE-79).
 */
export function parseBooleanParam(value: unknown): boolean {
    if (typeof value === 'boolean') {
        return value;
    }
    if (typeof value === 'string') {
        return value.trim().toLowerCase() === 'true';
    }
    return false;
}

declare class Android {
    static androidClose();
    static getSurveyPayload();
    static getContextPayload();
    static getUserPayload();
    static getExtraPayload();
    static invokeNative(params: { event_message: string });
    static surveyCloseEmbedded(data: string);
}

declare const webkit: any;

export const enum OSName {
    MAC = 'Mac OS',
    IOS = 'iOS',
    WINDOWS = 'Windows',
    ANDROID = 'Android',
    LINUX = 'Linux',
}

export const SUPPORT_THEMES = {
    OMRE: 'OMRE',
    VIN_ID: 'VINID',
    ONEU: 'ONEU',
};

export const enum SUPPORT_THEMES_CLASS {
    OMRE = 'omre-theme',
    VIN_ID = 'vin-id-theme',
    POP_UP = 'popup',
    EMBEDDED = 'embedded',
    QUIZ = 'quiz',
    ONEU = 'oneu-theme',
}

export const SURVEY_EMBEDDED_POPUP_READY = {
    SURVEY_PAY_LOAD_READY: 'SURVEY_PAY_LOAD_READY',
    SURVEY_CONTEXT_READY: 'SURVEY_CONTEXT_READY',
    SURVEY_USER_READY: 'SURVEY_USER_READY',
    SURVEY_EXTRA_READY: 'SURVEY_EXTRA_READY',
    SURVEY_GET_TOKEN: 'SURVEY_GET_TOKEN',
    SURVEY_GET_INFO_FORMS_DATA: 'INFO_FORMS_DATA',
    SURVEY_GET_VALID_VALUE: 'SURVEY_GET_VALID_VALUE',
    SURVEY_POST_VALID_VALUE: 'SURVEY_POST_VALID_VALUE',
    SURVEY_INFO_FORMS_RESULT: 'SURVEY_INFO_FORMS_RESULT',
    SURVEY_POST_VALID_VALUE_IOS: 'SURVEY_POST_VALID_VALUE_IOS',
    SURVEY_GET_CURRENT_FORM_VALUE: 'SURVEY_GET_CURRENT_FORM_VALUE',
    SURVEY_SET_FORM_VALUE: 'SURVEY_SET_FORM_VALUE',
    SURVEY_POST_CURRENT_FORM_VALUE: 'SURVEY_POST_CURRENT_FORM_VALUE',
    SURVEY_FORM_VALUE_COPIED: 'SURVEY_FORM_VALUE_COPIED',
    SURVEY_GET_FIRST_QUESTION: 'SURVEY_GET_FIRST_QUESTION',
    SURVEY_SUBMIT_BUTTON_TAP: 'SUBMIT_BUTTON_TAP',
    SURVEY_GET_DEVICE_INFO: 'GET_DEVICE_INFO',
    SURVEY_EMBEDDED_QUESTION_ANSWERED: 'SURVEY_EMBEDDED_QUESTION_ANSWERED',
    SURVEY_QUIZ_CUSTOM_QUESTIONS: 'SURVEY_QUIZ_CUSTOM_QUESTIONS',
};

@Injectable({ providedIn: 'root' })
export class SurveyForceStoreService {
    private _surveyData: Survey = null;
    private _surveyHandledData: SurveyHandledData[] = [];
    private _surveyFormGroup: FormGroup = null;
    private _autoNextPage: Subject<any> = new Subject();
    private _hiddenFieldsList: BehaviorSubject<string[]> = new BehaviorSubject(
        []
    );
    private _isTriggeredByButton: BehaviorSubject<boolean> =
        new BehaviorSubject(false);
    private _isCompleted = false;
    private _formValidateDirty: BehaviorSubject<string> = new BehaviorSubject(
        ''
    );
    private _groupLogicObj: GroupLogicObject = {};
    private _appData: AppData = {
        uuid: '',
        app_id: '',
        app_theme: '',
        submittedByAppLanguage: '',
        submittedByAppName: '',
        submittedByAppVersion: '',
        submittedByOperation: '',
        user_id: '',
        profile_name: '',
        profile_phone: '',
        profile_email: '',
        profile_employee_id: '',
        profile_company: '',
        profile_dob: '',
        profile_address: '',
        message_id: '',
        is_banner: false,
        anonymous_id: '',
        embedded_value: '',
        host: '',
        device_id: '',
        is_view_only: false,
        is_multi_approval: false,
        taker_id: '',
        reviewer_id: '',
        is_cdm_edit_survey: false,
        is_mobile_frame_cover: false,
        is_web_embedded: false,
        is_info_form: false,
        is_ignore_item_type_check: false,
        feedback_component_id: '',
        is_quiz_widget: false,
        is_pull_to_refresh: false,
        is_info_form_mock_data: '', //for testing only
    };
    private _device = '';
    private _questionsCountObj: { [key: string]: number } = {};
    private _currentPage = '';
    private _appTheme: BehaviorSubject<string> = new BehaviorSubject('');
    private _formStatusChanged: Subject<any> = new Subject();
    private _extraData: BehaviorSubject<UnknowObject> = new BehaviorSubject(
        null
    );
    private _isSetTrackingData = false;
    private _isResetEmbedded: Subject<any> = new Subject();
    //Authen token Variables
    private _type: BehaviorSubject<string> = new BehaviorSubject('bearer');
    private _accessToken: BehaviorSubject<string> = new BehaviorSubject('');
    //-------------
    private _closeAbandoned: Subject<any> = new Subject();
    private _approvalSurveyExtraReady: Subject<any> = new Subject();
    private _infoFormsData: BehaviorSubject<InfoFormData[]> =
        new BehaviorSubject([]);
    private _getValidValue: Subject<any> = new Subject();
    private _getCurrentFormValue: Subject<any> = new Subject();
    private _setFormValue: Subject<any> = new Subject();
    private _updateUiPassiveValueChanged: Subject<any> = new Subject();
    private _getFirstQuestion: Subject<any> = new Subject();
    private _isAppSetAnonymousIdLocalStorage: Subject<any> = new Subject();
    private _isAppHeightSet = false;
    private _questionComponentValue: BehaviorSubject<
        string | number | string[]
    > = new BehaviorSubject('');
    private _quizResults: QuizResult[] = [];
    private _customQuestions: BehaviorSubject<UnknowObject[]> =
        new BehaviorSubject([]);
    private _miniAppInstance: UnknowObject = null;
    private _isMiniApp = false;
    private _trackingSdk = null;
    constructor(
        @Inject(DOCUMENT) private _document: Document,
        private _fuseLoadingService: FuseLoadingService,
        private _loadingService: CustomLoadingService,
        private _router: Router
    ) {
        this._initApp();
    }
    public getSurveyData = (): Survey => this._surveyData || null;
    public getSurveyHandledData = (): SurveyHandledData[] =>
        this._surveyHandledData || [];
    public getSurveyFormGroup = (): FormGroup => this._surveyFormGroup || null;
    public initSurveyData = (surveyData: Survey): void => {
        this._setSurveyData(surveyData);
        const {
            Data: { layout = [], logics = [] },
        } = surveyData;
        let formGroup = {};
        for (const logic of logics) {
            if ((logic?.if as any)?.condition) {
                this.collectGroupLogics(
                    logic.if as IfConditionLogic,
                    logic.do,
                    logic.else
                );
            }
        }
        this._setSurveyHandledData(
            layout.map((layoutItem, i) => {
                const {
                    body: { items = [], id = '' },
                } = layoutItem;
                if (!!!this.getCurrentPage()) {
                    this.setCurrentPage(id);
                }
                if (!this._questionsCountObj.hasOwnProperty(id)) {
                    this._questionsCountObj[id] = items.length;
                }
                let formLayout = {};
                const itemsData = items.map((item) => {
                    const formControl = this._createFormControl(item, id);
                    if (formControl) {
                        formLayout = {
                            ...formLayout,
                            ...formControl,
                        };
                    }
                    const groupLogic = this.findInGroupLogics(item.id);
                    const logic =
                        logics.filter(
                            (logicItem: any) =>
                                logicItem?.if?.component_id === item.id
                        ) || [];

                    if (
                        item.type === LAYOUT_ITEM_TYPE.dropdownMenu ||
                        item.type === LAYOUT_ITEM_TYPE.singleSelectHorizon ||
                        item.type === LAYOUT_ITEM_TYPE.singleSelectVertical ||
                        item.type === LAYOUT_ITEM_TYPE.multiSelectHorizon ||
                        item.type === LAYOUT_ITEM_TYPE.multiSelectVertical ||
                        item.type === LAYOUT_ITEM_TYPE.singleSelectQuiz ||
                        item.type === LAYOUT_ITEM_TYPE.multiSelectQuiz ||
                        item.type === LAYOUT_ITEM_TYPE.tags ||
                        item.type === LAYOUT_ITEM_TYPE.dropdownMenu
                    ) {
                        const { validation, data } = item;
                        if (
                            validation.isRandom &&
                            data.items &&
                            data.items.length
                        ) {
                            const options = [...data.items];
                            const lastOptions =
                                data.items[data.items.length - 1];
                            let isOtherInput = false;
                            if (
                                lastOptions.isOtherInput ||
                                lastOptions.isExclusiveAnswer
                            ) {
                                isOtherInput = true;
                                options.pop();
                            }
                            const { random_end_index, random_start_index } =
                                data;
                            const randomOptions = this._shuffleArray(
                                options,
                                random_start_index,
                                random_end_index
                            );
                            if (isOtherInput) {
                                randomOptions.push(lastOptions);
                            }
                            item.data.items = randomOptions;
                        }
                    }

                    return {
                        groupFormName: id,
                        ...item,
                        groupLogic,
                        controlFormName: `${id}/${item.id}/${item.type}`,
                        logic,
                        position: i,
                    };
                });
                formGroup = { ...formGroup, [id]: new FormGroup(formLayout) };
                return {
                    id,
                    items: itemsData,
                };
            })
        );
        this._setSurveyFormGroup(new FormGroup(formGroup));
    };
    public triggerAutoNextPage(): void {
        this._autoNextPage.next({});
    }
    public watchAutoNextPage(): Observable<any> {
        return this._autoNextPage.asObservable();
    }
    public watchHiddenList(): Observable<string[]> {
        return this._hiddenFieldsList.asObservable();
    }
    public addToHiddenList(id: string): void {
        const hiddenList = this._getHiddenList();
        if (hiddenList.indexOf(id) === -1) {
            hiddenList.push(id);
            this._hiddenFieldsList.next(hiddenList);
        }
    }
    public removeFromHiddenList(id: string): void {
        const hiddenList = this._getHiddenList();
        const index = hiddenList.indexOf(id);
        if (index !== -1) {
            hiddenList.splice(index, 1);
            this._hiddenFieldsList.next(hiddenList);
        }
    }
    public getAppData(key?: string): any {
        if (key) {
            return this._appData[key];
        }
        return this._appData;
    }
    public toggleLoadingButton(): void {
        this._isTriggeredByButton.next(!this._isTriggeredByButton.getValue());
    }
    public verifyCompleted(): void {
        if (!this._isCompleted) {
            this._isCompleted = true;
        }
    }
    public checkIsCompleted(): boolean {
        return this._isCompleted;
    }
    public watchLoadingButton(): Observable<boolean> {
        return this._isTriggeredByButton.asObservable();
    }
    public triggerDirtyForm(formName: string): void {
        this._formValidateDirty.next(formName);
    }
    public watchDirtyFormName(): Observable<string> {
        return this._formValidateDirty.asObservable();
    }
    public findInGroupLogics(componentId: string): GroupLogic[] {
        const result = [];
        for (const key of Object.keys(this._groupLogicObj)) {
            if (
                this._groupLogicObj[key].positionList.some(
                    (pos) => pos?.condition.component_id === componentId
                )
            ) {
                result.push(this._groupLogicObj[key]);
            }
        }
        return result;
    }
    public setToCookie(key: string, value: string, expires: number = 0): void {
        if (key && value) {
            Cookies.set(key, value, { expires });
        }
    }
    public deleteCookie(key: string): void {
        if (key) {
            Cookies.remove(key);
        }
    }
    public getAllCookies(): string {
        return document.cookie;
    }
    public getCookie(key: string): string {
        return Cookies.get(key) || '';
    }
    public isCookieExist(key: string): boolean {
        return !!this.getCookie(key);
    }
    public getDevice(): string {
        return this._device;
    }
    public closeWebView(): void {
        if (this._isMiniApp) {
            this._miniAppInstance?.close();
            return;
        }
        switch (this._device) {
            case OSName.IOS:
                this._closeIOS();
                return;
            case OSName.ANDROID:
                this._closeAndroid();
                return;
            default:
                return;
        }
    }
    public setToLocalStorage(key: string, value: string): void {
        if (key && value) {
            const escapseData = encodeURI(value);
            localStorage.setItem(key, escapseData);
        }
    }
    public removeLocalStorage(key: string): void {
        if (key) {
            localStorage.removeItem(key);
        }
    }
    public getLocalStorage(key: string): string {
        if (key) {
            const data = localStorage.getItem(key);
            if (data) {
                return decodeURI(localStorage.getItem(key));
            }
        }
        return '';
    }
    public isLocalStorageExist(key: string): boolean {
        if (key) {
            return !!localStorage.getItem(key);
        }
        return false;
    }
    public getLocalStorageKey(): string {
        const {
            uuid = '',
            user_id = '',
            message_id = '',
            anonymous_id = '',
        } = this.getAppData();
        return `${uuid}/${user_id || 'none'}/${message_id}/${
            user_id ? 'none' : anonymous_id || 'none'
        }`;
    }
    public countQuestionsPerPage(pageName: string): number {
        return this._questionsCountObj[pageName] || 0;
    }
    public getCurrentPage(): string {
        return this._currentPage || '';
    }
    public setCurrentPage(pageId: string): void {
        this._currentPage = pageId;
    }
    public getAppTheme(): string {
        return this._appTheme.getValue() || '';
    }
    public watchAppTheme(): Observable<string> {
        return this._appTheme.asObservable();
    }
    public setQueryParams(querryParams: Params): void {
        let {
            uuid = '',
            user_id = '',
            message_id = '',
            is_banner = '',
            app_theme = '',
            anonymous_id = '',
            embedded_value = '',
            host = '',
            is_view_only = false,
            is_multi_approval = false,
            taker_id = '',
            reviewer_id = '',
            is_cdm_edit_survey = false,
            is_mobile_frame_cover = false,
            is_web_embedded = false,
            is_info_form = false,
            is_ignore_item_type_check = false,
            feedback_component_id = '',
            is_quiz_widget = false,
            is_pull_to_refresh = false,
            is_info_form_mock_data = '', //for testing only
        } = this.getAppData();

        uuid = querryParams.uuid || '';
        user_id = querryParams.user_id || '';
        anonymous_id = querryParams.anonymous_id || '';
        message_id = querryParams.message_id || '';
        is_banner = parseBooleanParam(querryParams.is_banner);
        app_theme = querryParams.app_theme || '';
        embedded_value = querryParams.embedded_value || '';
        host = querryParams.host || '';
        is_view_only = parseBooleanParam(querryParams.is_view_only);
        is_multi_approval = parseBooleanParam(querryParams.is_multi_approval);
        taker_id = querryParams.taker_id || '';
        reviewer_id = querryParams.reviewer_id || '';
        is_cdm_edit_survey = parseBooleanParam(querryParams.is_cdm_edit_survey);
        is_mobile_frame_cover = parseBooleanParam(
            querryParams.is_mobile_frame_cover
        );
        is_web_embedded = parseBooleanParam(querryParams.is_web_embedded);
        is_info_form = parseBooleanParam(querryParams.is_info_form);
        is_ignore_item_type_check = parseBooleanParam(
            querryParams.is_ignore_item_type_check
        );
        feedback_component_id = querryParams.feedback_component_id || '';
        is_info_form_mock_data = querryParams.is_info_form_mock_data || '';
        is_quiz_widget = parseBooleanParam(querryParams.is_quiz_widget);
        is_pull_to_refresh = parseBooleanParam(querryParams.is_pull_to_refresh);
        this._applyAppTheme(app_theme);
        this._setAppDAta({
            uuid,
            user_id,
            message_id,
            is_banner,
            app_theme,
            anonymous_id,
            embedded_value,
            host,
            is_view_only,
            is_multi_approval,
            taker_id,
            reviewer_id,
            is_cdm_edit_survey,
            is_mobile_frame_cover,
            is_web_embedded,
            is_info_form,
            is_ignore_item_type_check,
            feedback_component_id,
            is_info_form_mock_data,
            is_quiz_widget,
            is_pull_to_refresh,
        });
    }
    public formStatusChanged(): void {
        this._formStatusChanged.next({});
    }
    public watchFormStatuschanged(): Observable<any> {
        return this._formStatusChanged.asObservable();
    }
    public getFirstQuestion(data: Survey): BodyItem {
        return data?.Data?.layout[0]?.body?.items[0] || null;
    }
    public postMessageOutside(message: string): void {
        window.parent.postMessage(message, '*');
    }
    public getDomain(): string {
        return this._document.location.origin || '';
    }
    public getPagePath(): string {
        return this._document.location.pathname || '';
    }
    public showLoadingBar(): void {
        switch (this.getPagePath()) {
            case `/${APP_PATH.SURVEY_FORCE_POPUP}`:
            case `/${APP_PATH.SURVEY_FORCE_EMBEDDED}`:
            case `/${APP_PATH.INFO_FORMS}`:
                this._loadingService.show();
                break;
            case `/${APP_PATH.SURVEY_FORCE}`:
            default:
                this._fuseLoadingService.show();
                break;
        }
    }
    public hideLoadingBar(): void {
        switch (this.getPagePath()) {
            case `/${APP_PATH.SURVEY_FORCE_POPUP}`:
            case `/${APP_PATH.SURVEY_FORCE_EMBEDDED}`:
            case `/${APP_PATH.INFO_FORMS}`:
                this._loadingService.hide();
                break;
            case `/${APP_PATH.SURVEY_FORCE}`:
            default:
                this._fuseLoadingService.hide();
                break;
        }
    }
    public addClassBody(bodyClass: SUPPORT_THEMES_CLASS): void {
        this._document.body.classList.add(bodyClass);
    }
    public getExtraData(): UnknowObject {
        return this._extraData.getValue() || null;
    }
    public getNFirstCharacters(text: string, n: number): string {
        return text.slice(0, n);
    }
    public getNLastCharacters(text: string, n: number): string {
        return text.substr(text.length - n);
    }
    public watchResetEmbedded(): Observable<any> {
        return this._isResetEmbedded.asObservable();
    }
    public navigateToErrorPage(message?: string): void {
        let url = '';
        switch (this.getPagePath()) {
            case `/${APP_PATH.SURVEY_FORCE_EMBEDDED}`:
                break;
            case `/${APP_PATH.SURVEY_FORCE_POPUP}`:
                url = `${APP_PATH.ERROR}/${APP_PATH.ERROR_400_POPUP}`;
                break;
            default:
                url = `${APP_PATH.ERROR}/${APP_PATH.ERROR_400}`;
                break;
        }
        if (url) {
            const params = this.getQueryParamsOnUrl();
            this._router.navigate([url], {
                queryParams: { ...(params || {}), message: message || '' },
                skipLocationChange: true,
            });
        }
    }
    public triggerPostInfoFormsResultOut(data: any): void {
        const eventName = SURVEY_EMBEDDED_POPUP_READY.SURVEY_INFO_FORMS_RESULT;
        if (this._isMiniApp) {
            this._miniAppInstance?.postMessageToNative(eventName, data);
            return;
        }
        const eventMessage = JSON.stringify({
            event_message: eventName,
            data,
        });
        if (this._appData.is_web_embedded) {
            this.postMessageOutside(eventMessage);
            return;
        }
        switch (this._device) {
            case OSName.IOS:
                if ((window as any)?.webkit?.messageHandlers?.invokeNative) {
                    (
                        window as any
                    )?.webkit?.messageHandlers?.invokeNative?.postMessage(
                        eventMessage
                    );
                }
                break;
            case OSName.ANDROID:
                if ((window as any)?.AndroidAppProxy?.invokeNative) {
                    (window as any)?.AndroidAppProxy?.invokeNative(
                        eventMessage
                    );
                }
                break;
            default:
                break;
        }
    }
    public triggerGetAuthenToken(): void {
        if (this._isMiniApp) {
            //refresh token here
            this._miniAppInstance
                ?.refreshToken()
                .then((token) => this._accessToken.next(token || ''));
            return;
        }
        if (this._appData.is_web_embedded) {
            this._postSurveyReadyMessage(
                SURVEY_EMBEDDED_POPUP_READY.SURVEY_GET_TOKEN
                // this._appData.uuid || ''
            );
            return;
        }
        const eventMessage = JSON.stringify({
            event_message: 'ACCESS_TOKEN',
        });
        switch (this._device) {
            case OSName.IOS:
                if ((window as any)?.webkit?.messageHandlers?.invokeNative) {
                    (
                        window as any
                    )?.webkit?.messageHandlers?.invokeNative?.postMessage(
                        eventMessage
                    );
                }
                break;
            case OSName.ANDROID:
                if ((window as any)?.AndroidAppProxy?.invokeNative) {
                    (window as any)?.AndroidAppProxy?.invokeNative(
                        eventMessage
                    );
                }
                break;
            default:
                break;
        }
    }
    public checkEndSurveyImmediately(
        currentStep: number,
        steps: number
    ): boolean {
        const svHandledData = this.getSurveyHandledData() || [];
        let isEnabled = false;
        for (let i = currentStep; i < steps; i++) {
            const items = [...svHandledData[i].items];
            if (i === 0) {
                items.shift();
            }
            const filteredItems = Array.isArray(items) ? items : [items];
            for (const item of filteredItems) {
                const [formGroupName, ...others] =
                    item.controlFormName.split('/');
                const formGroup = this.getSurveyFormGroup();
                if (
                    (formGroup.controls[formGroupName] as FormGroup)?.controls[
                        item.controlFormName
                    ]?.enabled
                ) {
                    isEnabled = true;
                    break;
                }
            }
            if (isEnabled) {
                break;
            }
        }
        return !isEnabled;
    }
    //Authen Token Functions
    public getTokenFromParents = (): void => {
        this.triggerGetAuthenToken();
    };

    public getToken = (): string => this._accessToken.getValue() || '';

    public watchToken = (): Observable<string> =>
        this._accessToken.asObservable();

    public getTokenType = (): string => this._type.getValue();

    public watchTokenType = (): Observable<string> => this._type.asObservable();
    // -------------
    public watchCloseAbandonedchanged(): Observable<any> {
        return this._closeAbandoned.asObservable();
    }
    public postAbandonedDataOutSide(data: string): void {
        try {
            if (this._isMiniApp) {
                this._miniAppInstance?.postMessageToNative(
                    'SURVEY_CLOSE_EMBEDDED',
                    JSON.parse(data)
                );
                return;
            }
            if (this._appData.is_web_embedded) {
                this.postMessageOutside(data);
                return;
            }
            switch (this._device) {
                case OSName.IOS:
                    if (typeof webkit !== 'undefined') {
                        if (webkit.messageHandlers?.surveyCloseEmbedded) {
                            webkit.messageHandlers?.surveyCloseEmbedded?.postMessage(
                                data
                            );
                        }
                    }
                    break;
                case OSName.ANDROID:
                    if (typeof Android !== 'undefined') {
                        if (Android.surveyCloseEmbedded) {
                            Android.surveyCloseEmbedded(data);
                        }
                    }
                    break;
                default:
                    break;
            }
        } catch (err) {
            console.log(err);
        }
    }
    public watchApprovalSurveyExtraReady(): Observable<any> {
        return this._approvalSurveyExtraReady.asObservable();
    }
    public watchExtraDataChange(): Observable<UnknowObject> {
        return this._extraData.asObservable();
    }
    public getPageUrl(): string {
        return window.location.href;
    }
    public getQueryParamsOnUrl(): any {
        const urlParams = new URLSearchParams(window.location.search);
        const params: any = {};
        urlParams.forEach((value, key) => {
            params[key] = value;
        });
        return params;
    }
    public watchInfoFormsData(): Observable<InfoFormData[]> {
        return this._infoFormsData.asObservable();
    }
    public setInfoFormsData(data: InfoFormData[]): void {
        this._infoFormsData.next(data || []);
    }
    public triggerGetInfoFormsData(): void {
        const eventName =
            SURVEY_EMBEDDED_POPUP_READY.SURVEY_GET_INFO_FORMS_DATA;
        if (this._isMiniApp) {
            this._miniAppInstance?.postMessageToNative(eventName);
            return;
        }
        if (this._appData.is_web_embedded) {
            this._postSurveyReadyMessage(eventName);
            return;
        }
        const eventMessage = JSON.stringify({
            event_message: eventName,
        });
        switch (this._device) {
            case OSName.IOS:
                if ((window as any)?.webkit?.messageHandlers?.invokeNative) {
                    (
                        window as any
                    )?.webkit?.messageHandlers?.invokeNative?.postMessage(
                        eventMessage
                    );
                }
                break;
            case OSName.ANDROID:
                if ((window as any)?.AndroidAppProxy?.invokeNative) {
                    (window as any)?.AndroidAppProxy?.invokeNative(
                        eventMessage
                    );
                }
                break;
            default:
                break;
        }
    }
    public watchGetValidValue(): Observable<any> {
        return this._getValidValue.asObservable();
    }
    public watchGetCurrentFormValue(): Observable<any> {
        return this._getCurrentFormValue.asObservable();
    }
    public watchSetFormValue(): Observable<any> {
        return this._setFormValue.asObservable();
    }
    public watchUpdatePassiveValueChanged(): Observable<any> {
        return this._updateUiPassiveValueChanged.asObservable();
    }
    public triggerUpdatePassiveValueChanged(): void {
        this._updateUiPassiveValueChanged.next({});
    }
    public handleAppHeight(): void {
        if (!this._isAppHeightSet) {
            window.addEventListener('resize', this._setAppHeight);
            this._setAppHeight();
            this._isAppHeightSet = true;
        }
    }
    public watchGetFirstQuestion(): Observable<any> {
        return this._getFirstQuestion.asObservable();
    }
    public checkIsFeedbackServicePath(): boolean {
        const pagePath = this.getPagePath();
        return (
            pagePath === `/${APP_PATH.SURVEY_FORCE_POPUP}` ||
            pagePath === `/${APP_PATH.SURVEY_FORCE_EMBEDDED}`
        );
    }
    public invokeOutSide(eventMessage: string): void {
        //App Only
        if (this._isMiniApp) {
            const { event_message, ...data } = JSON.parse(eventMessage);
            this._miniAppInstance?.postMessageToNative(event_message, data);
            return;
        }
        switch (this._device) {
            case OSName.IOS:
                if ((window as any)?.webkit?.messageHandlers?.invokeNative) {
                    (
                        window as any
                    )?.webkit?.messageHandlers?.invokeNative?.postMessage(
                        eventMessage
                    );
                }
                break;
            case OSName.ANDROID:
                if ((window as any)?.AndroidAppProxy?.invokeNative) {
                    (window as any)?.AndroidAppProxy?.invokeNative(
                        eventMessage
                    );
                }
                break;
            default:
                break;
        }
    }
    public watchQuestionComponentValue(): Observable<
        string | number | string[]
    > {
        return this._questionComponentValue.asObservable();
    }
    public getFeedbackWebComponentId(): string {
        return this._appData.feedback_component_id;
    }
    public closeIframe(): void {
        const { uuid = '' } = this._appData;
        const val = JSON.stringify({
            event_name: 'survey_popup_close_emit',
            uuid,
            fbwc: this._appData.feedback_component_id || '',
        });
        this.postMessageOutside(val);
    }
    public setQuizResult(res: QuizResult, index: number): void {
        this._quizResults.splice(index, 1, res);
    }
    public getQuizResults(): QuizResult[] {
        return this._quizResults || [];
    }
    public watchCustomQuestionsValue(): Observable<UnknowObject[]> {
        return this._customQuestions.asObservable();
    }
    public triggerGetCustomQuestions(): void {
        try {
            if (this._appData.is_web_embedded) {
                this._postSurveyReadyMessage(
                    SURVEY_EMBEDDED_POPUP_READY.SURVEY_QUIZ_CUSTOM_QUESTIONS,
                    this._appData.uuid || '',
                    this._appData.message_id || ''
                );
            }
        } catch (err) {
            console.log(err);
        }
    }
    private _initApp(): void {
        // this._isMiniApp = checkAppOpenedOnMiniApp();
        console.log(`isMiniApp ${this._isMiniApp}`);
        InitMiniApp().then((minApp) => {
            this._miniAppInstance = minApp;
            console.log('onemount mini-app-module instance: ', minApp);
            this._applyContextData();
            this._configWebview();
            this._emitCloseLoadingMiniApp();
            this._configInfoFormsNavBar();
            this._receiveMessageOutside();
            this._triggerOutsidePostData();
            this._initTrackingSDK();
        });
    }
    private _receiveMessageOutside(): void {
        window.addEventListener('message', this._receiveMessageFromClient);
    }
    public getTrackingSdk(): any {
        return this._trackingSdk;
    }
    private _subscribeTrackingSdkV2(): void {
        this._trackingSdk = initializeApp({
            clientId: environment.TRACKING_SDK.clientId,
            env: environment.TRACKING_SDK.env as any,
        });
        this._trackingSdk.customizeApplication({
            env: environment.TRACKING_SDK.env as any,
        });
        if (this._appData.user_id) {
            this._trackingSdk?.setUserId(this._appData.user_id);
        } else {
            this._trackingSdk?.setUserLogout();
        }
        if (this._checkIsSurveyPath()) {
            this._triggerGetContextPayload();
        }
    }
    private _initTrackingSDK(): void {
        if (this._appData.is_web_embedded) {
            this._subscribeTrackingSdkV2();
            return;
        }
        this._watchAppSetAnonymousLocalStorage()
            .pipe(take(1))
            .subscribe((val) => {
                this._subscribeTrackingSdkV2();
            });
    }
    private _triggerGetAppDeviceInfo(): void {
        const eventName = SURVEY_EMBEDDED_POPUP_READY.SURVEY_GET_DEVICE_INFO;
        const eventMessage = JSON.stringify({
            event_message: eventName,
            data: {},
        });
        this.invokeOutSide(eventMessage);
    }
    private _setAppHeight(): void {
        const doc = document.documentElement;
        doc.style.setProperty('--app-height', `${window.innerHeight}px`);
    }
    private _checkIsSurveyPath(): boolean {
        const pagePath = this.getPagePath();
        return (
            pagePath === `/${APP_PATH.START}` ||
            pagePath === `/${APP_PATH.SURVEY_FORCE}` ||
            pagePath === `/${APP_PATH.SURVEY_FORCE_POPUP}` ||
            pagePath === `/${APP_PATH.SURVEY_FORCE_EMBEDDED}` ||
            pagePath === `/${APP_PATH.SURVEY_FORCE_QUIZ}`
        );
    }
    private _checkPath(path: string): boolean {
        const pagePath = this.getPagePath();
        return pagePath === `/${path}`;
    }
    private _triggerOutsidePostData(): void {
        if (!this._appData.is_web_embedded) {
            this._triggerGetAppDeviceInfo();
        }
        const isSurveyPath = this._checkIsSurveyPath();
        if (isSurveyPath) {
            this._triggerGetSurveyPayLoad();
            this._triggerGetUserPayload();
        }
        if (isSurveyPath || this._checkPath(APP_PATH.APPROVE)) {
            this._triggerGetExtraPayload();
        }
    }
    private _postConfigNavbAR(): void {
        const data = {
            show: true,
            show_default_action: false,
            title: {
                text: 'Thông tin cá nhân',
            },
            actions: [
                {
                    image_url:
                        'https://logowik.com/content/uploads/images/close1437.jpg',
                    js_event_name: 'ACTION_CLOSE',
                    icon_type: 'RIGHT',
                },
            ],
        };
        const eventMessage = 'SETUP_NAVBAR';
        if (this._isMiniApp) {
            this._miniAppInstance?.postMessageToNative(eventMessage, data);
            return;
        }
        const message = JSON.stringify({
            event_message: eventMessage,
            data,
        });
        switch (this._device) {
            case OSName.IOS:
                if ((window as any)?.webkit?.messageHandlers?.invokeNative) {
                    (
                        window as any
                    )?.webkit?.messageHandlers?.invokeNative?.postMessage(
                        message
                    );
                }
                break;
            case OSName.ANDROID:
                // if ((window as any)?.AndroidAppProxy?.invokeNative) {
                //     (window as any)?.AndroidAppProxy?.invokeNative(message);
                // }
                break;
            default:
                break;
        }
    }
    private _invokeNative(message: string): void {
        switch (this._device) {
            case OSName.IOS:
                if ((window as any)?.webkit?.messageHandlers?.invokeNative) {
                    (
                        window as any
                    )?.webkit?.messageHandlers?.invokeNative?.postMessage(
                        message
                    );
                }
                break;
            case OSName.ANDROID:
                if ((window as any)?.AndroidAppProxy?.invokeNative) {
                    (window as any)?.AndroidAppProxy?.invokeNative(message);
                }
                break;
            default:
                break;
        }
    }
    private _configWebview(): void {
        const { is_pull_to_refresh } = this._appData;
        if (this._isMiniApp) {
            this._miniAppInstance?.updateMiniappConfig(
                false,
                false,
                is_pull_to_refresh,
                false
            );
            return;
        }
        const message = JSON.stringify({
            event_message: 'CONFIG_WEB_VIEW',
            data: {
                enable_zoom: false,
                enable_console_log: false,
                enable_pull_to_refresh: is_pull_to_refresh,
            },
        });
        this._invokeNative(message);
    }
    private _emitCloseLoadingMiniApp(): void {
        if (this._isMiniApp) {
            this._miniAppInstance?.hideLoading();
            return;
        }
        const message = JSON.stringify({
            event_message: 'SET_LOADING',
            data: {
                is_show_loading: false,
            },
        });
        this._invokeNative(message);
    }
    private _configInfoFormsNavBar(): void {
        if (
            !this._appData.is_web_embedded &&
            this._checkPath(APP_PATH.INFO_FORMS)
        ) {
            this._postConfigNavbAR();
        }
    }
    private _applyContextData(): void {
        const params = this.getQueryParamsOnUrl();
        this.setQueryParams(params);
        this._device = this._getOS();
    }
    private _triggerResetEmbeddedSurvey(): void {
        this._isResetEmbedded.next({});
    }
    private _setExtraData(val: any) {
        this._extraData.next(val);
    }
    private _applyAppTheme(theme: string): void {
        console.log('Theme using is: ', theme);
        if (!this.getAppTheme()) {
            this._appTheme.next(theme || '');
            const themeValue = this._appTheme.getValue();

            switch (themeValue) {
                case SUPPORT_THEMES.OMRE:
                    this._document.body.classList.add(
                        SUPPORT_THEMES_CLASS.OMRE
                    );
                    break;
                case SUPPORT_THEMES.ONEU:
                    this._document.body.classList.add(
                        SUPPORT_THEMES_CLASS.ONEU
                    );
                    break;
                case SUPPORT_THEMES.VIN_ID:
                default:
                    this._document.body.classList.add(
                        SUPPORT_THEMES_CLASS.VIN_ID
                    );
                    break;
            }
        }
    }
    private setBooleanAppData(key: string, value: any): void {
        const parsedValue = parseBooleanParam(value);
        if (this._appData[key] !== parsedValue) {
            this._appData[key] = parsedValue;
        }
    }
    private _sendTrackingContextData = () => {
        if (!this._isSetTrackingData) {
            if (this._appData.app_namespace) {
                this._trackingSdk?.setContext({
                    build: this._appData.app_build || '',
                    name: this._appData.app_name || '',
                    version: this._appData.app_version || '',
                    device_id: this._appData.device_id || '',
                });
                this._trackingSdk?.customizeApplication({
                    namespace: this._appData.app_namespace,
                });
                this._trackingSdk?.insertCommonParams({
                    host: this._appData.app_namespace,
                });
                this._isSetTrackingData = true;
            }
        }
    };
    private _setAppDAta(data: AppDataSetParam): void {
        for (const key of Object.keys(data)) {
            if (!this._appData[key]) {
                switch (key) {
                    case 'is_banner':
                    case 'is_view_only':
                    case 'is_multi_approval':
                    case 'is_cdm_edit_survey':
                    case 'is_mobile_frame_cover':
                    case 'is_web_embedded':
                    case 'is_info_form':
                    case 'is_ignore_item_type_check':
                    case 'is_quiz_widget':
                    case 'is_pull_to_refresh':
                        this.setBooleanAppData(key, data[key]);
                        break;
                    default:
                        this._appData[key] = data[key];
                        break;
                }
            }
        }
        this._sendTrackingContextData();
    }
    private _getAnonymousIdForApp = (data: any) => {
        if (!this._appData.is_web_embedded) {
            const { anonymous_id } = data;
            this.setToLocalStorage('anonymous_id', anonymous_id);
            this._setAppDAta({ anonymous_id });
            this._isAppSetAnonymousIdLocalStorage.next({});
        }
    };
    private _handleMessageInvokeNative = (eventMessage: string, data: any) => {
        switch (eventMessage) {
            case 'AUTHENTICATION_DATA':
                if (data.error_code) {
                    this.hideLoadingBar();
                    this.navigateToErrorPage(data.error_message || '');
                    return;
                }
                this._accessToken.next(data.access_token || '');
                return;
            case SURVEY_EMBEDDED_POPUP_READY.SURVEY_GET_INFO_FORMS_DATA:
                this.setInfoFormsData(data?.message || []);
                return;
            case SURVEY_EMBEDDED_POPUP_READY.SURVEY_GET_VALID_VALUE:
                this._getValidValue.next({});
                return;
            case SURVEY_EMBEDDED_POPUP_READY.SURVEY_GET_CURRENT_FORM_VALUE:
                this._getCurrentFormValue.next({});
                return;
            case SURVEY_EMBEDDED_POPUP_READY.SURVEY_SET_FORM_VALUE:
                this._setFormValue.next(data || null);
                return;
            case SURVEY_EMBEDDED_POPUP_READY.SURVEY_GET_FIRST_QUESTION:
                this._getFirstQuestion.next({});
                return;
            case SURVEY_EMBEDDED_POPUP_READY.SURVEY_GET_DEVICE_INFO:
                this._getAnonymousIdForApp(data);
                return;
            case SURVEY_EMBEDDED_POPUP_READY.SURVEY_EMBEDDED_QUESTION_ANSWERED:
                this._questionComponentValue.next(data);
                return;
            default:
                return;
        }
    };
    private _watchAppSetAnonymousLocalStorage(): Observable<any> {
        return this._isAppSetAnonymousIdLocalStorage.asObservable();
    }
    private _handleMessageNoHung = (eventName: string, data: any) => {
        switch (eventName) {
            case 'survey_payload':
            case 'context_payload':
            case 'user_payload':
                this._setAppDAta(data);
                return;
            case 'extra_payload':
                this._setExtraData(data);
                return;
            case 'reset_embedded_payload':
                this._triggerResetEmbeddedSurvey();
                return;
            case 'close_abandoned_trigger':
                this._closeAbandoned.next({});
                return;
            case SURVEY_EMBEDDED_POPUP_READY.SURVEY_EXTRA_READY:
                this._approvalSurveyExtraReady.next({});
                return;
            case SURVEY_EMBEDDED_POPUP_READY.SURVEY_QUIZ_CUSTOM_QUESTIONS:
                this._customQuestions.next(data);
                return;
            default:
                return;
        }
    };
    private _receiveMessageFromClient = (event?: any) => {
        try {
            if (event.data) {
                const {
                    event_name = '',
                    data = null,
                    event_message = '',
                } = typeof event.data === 'string'
                    ? JSON.parse(event.data)
                    : event.data;
                if (event_message) {
                    this._handleMessageInvokeNative(event_message, data);
                    return;
                }
                this._handleMessageNoHung(event_name, data);
            }
        } catch (err) {
            console.log(err);
        }
    };
    private _postSurveyReadyMessage(
        eventName: string,
        uuid?: string,
        messageId?: string
    ): void {
        this.postMessageOutside(
            JSON.stringify({
                event_name: eventName,
                data: `${this._document.URL}`,
                ...(uuid ? { uuid } : {}),
                ...(messageId ? { message_id: messageId } : {}),
            })
        );
    }
    private _triggerGetSurveyPayLoad(): void {
        try {
            if (this._isMiniApp) {
                this._miniAppInstance?.postMessageToNative(
                    'SURVEY_GET_SURVEY_PAYLOAD'
                );
                return;
            }
            if (this._appData.is_web_embedded) {
                this._postSurveyReadyMessage(
                    SURVEY_EMBEDDED_POPUP_READY.SURVEY_PAY_LOAD_READY,
                    this._appData.uuid || '',
                    this._appData.message_id || ''
                );
                return;
            }
            switch (this._device) {
                case OSName.IOS:
                    if (typeof webkit !== 'undefined') {
                        if (webkit.messageHandlers?.getSurveyPayload) {
                            webkit.messageHandlers?.getSurveyPayload?.postMessage(
                                {}
                            );
                        }
                    }
                    break;
                case OSName.ANDROID:
                    if (typeof Android !== 'undefined') {
                        if (Android.getSurveyPayload) {
                            Android.getSurveyPayload();
                        }
                    }
                    break;
                default:
                    break;
            }
        } catch (err) {
            console.log(err);
        }
    }
    private _triggerGetContextPayload(): void {
        try {
            if (this._isMiniApp) {
                this._miniAppInstance?.postMessageToNative(
                    'SURVEY_GET_CONTEXT_PAYLOAD'
                );
                return;
            }
            if (this._appData.is_web_embedded) {
                this._postSurveyReadyMessage(
                    SURVEY_EMBEDDED_POPUP_READY.SURVEY_CONTEXT_READY,
                    this._appData.uuid || '',
                    this._appData.message_id || ''
                );
                return;
            }
            switch (this._device) {
                case OSName.IOS:
                    if (typeof webkit !== 'undefined') {
                        if (webkit.messageHandlers?.getContextPayload) {
                            webkit.messageHandlers?.getContextPayload?.postMessage(
                                {}
                            );
                        }
                    }
                    break;
                case OSName.ANDROID:
                    if (typeof Android !== 'undefined') {
                        if (Android.getContextPayload) {
                            Android.getContextPayload();
                        }
                    }
                    break;
                default:
                    break;
            }
        } catch (err) {
            console.log(err);
        }
    }
    private _triggerGetUserPayload(): void {
        try {
            if (this._isMiniApp) {
                this._miniAppInstance?.postMessageToNative(
                    'SURVEY_GET_USER_PAYLOAD'
                );
                return;
            }
            if (this._appData.is_web_embedded) {
                this._postSurveyReadyMessage(
                    SURVEY_EMBEDDED_POPUP_READY.SURVEY_USER_READY,
                    this._appData.uuid || ''
                );
                return;
            }
            switch (this._device) {
                case OSName.IOS:
                    if (typeof webkit !== 'undefined') {
                        if (webkit.messageHandlers?.getUserPayload) {
                            webkit.messageHandlers?.getUserPayload?.postMessage(
                                {}
                            );
                        }
                    }
                    break;
                case OSName.ANDROID:
                    if (typeof Android !== 'undefined') {
                        if (Android.getUserPayload) {
                            Android.getUserPayload();
                        }
                    }
                    break;
                default:
                    break;
            }
        } catch (err) {
            console.log(err);
        }
    }
    private _triggerGetExtraPayload(): void {
        try {
            if (this._isMiniApp) {
                this._miniAppInstance?.postMessageToNative(
                    'SURVEY_GET_EXTRA_PAYLOAD'
                );
                return;
            }
            if (this._appData.is_web_embedded) {
                this._postSurveyReadyMessage(
                    SURVEY_EMBEDDED_POPUP_READY.SURVEY_EXTRA_READY,
                    this._appData.uuid || ''
                );
                return;
            }
            switch (this._device) {
                case OSName.IOS:
                    if (typeof webkit !== 'undefined') {
                        if (webkit.messageHandlers?.getExtraPayload) {
                            webkit.messageHandlers?.getExtraPayload?.postMessage(
                                {}
                            );
                        }
                    }
                    break;
                case OSName.ANDROID:
                    if (typeof Android !== 'undefined') {
                        if (Android.getExtraPayload) {
                            Android.getExtraPayload();
                        }
                    }
                    break;
                default:
                    break;
            }
        } catch (err) {
            console.log(err);
        }
    }
    private _shuffleArray(
        array: UnknowObject[],
        start: number,
        end: number
    ): UnknowObject[] {
        const res = array;
        for (let i = end; i > start; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [res[i], res[j]] = [res[j], res[i]];
        }
        return res;
    }
    private _closeAndroid(): void {
        try {
            if (typeof Android !== 'undefined') {
                Android.androidClose();
            }
        } catch (err) {
            console.log(err);
        }
    }
    private _closeIOS(): void {
        try {
            if (typeof webkit !== 'undefined') {
                webkit.messageHandlers?.iOSClose?.postMessage({});
            }
        } catch (err) {
            console.log(err);
        }
    }
    private _getOS(): string {
        const userAgent = window.navigator.userAgent;
        const platform =
            (window.navigator as any).userAgentData?.platform ||
            window.navigator.platform;
        const macosPlatforms = [
            'Macintosh',
            'MacIntel',
            'MacPPC',
            'Mac68K',
            'macOS',
        ];
        const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
        const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
        let os = '';
        if (macosPlatforms.indexOf(platform) !== -1) {
            os = OSName.MAC;
        } else if (iosPlatforms.indexOf(platform) !== -1) {
            os = OSName.IOS;
        } else if (windowsPlatforms.indexOf(platform) !== -1) {
            os = OSName.WINDOWS;
        } else if (/Android/.test(userAgent)) {
            os = OSName.ANDROID;
        } else if (/Linux/.test(platform)) {
            os = OSName.LINUX;
        }

        return os;
    }
    private collectGroupLogics(
        ifCondition: IfConditionLogic,
        doCondition: DoLogic[],
        elseCondition: ElseLogic[],
        position: number = 0,
        logicGroupId: string = ''
    ): string {
        let currentPos = position;
        let cString = '';
        const subConditions =
            ifCondition.condition.and || ifCondition.condition.or;
        let groupId = logicGroupId;
        if (subConditions) {
            const conditionOperator = this._getConditionOperator(
                ifCondition.condition
            );
            if (conditionOperator) {
                for (let i = 0; i < subConditions.length; i++) {
                    if ((subConditions[i] as IfConditionLogic).condition) {
                        cString = `${cString} (${this.collectGroupLogics(
                            subConditions[i] as IfConditionLogic,
                            doCondition,
                            elseCondition,
                            currentPos,
                            groupId
                        )})${
                            i < subConditions.length - 1
                                ? ' ' + conditionOperator
                                : ''
                        }`;
                    } else {
                        cString = `${cString} {${++currentPos}}${
                            i < subConditions.length - 1
                                ? ' ' + conditionOperator
                                : ''
                        }`;
                        if (!groupId) {
                            groupId = (subConditions[i] as IfLogic).target_id;
                        }
                        this._setGroupLogicObj(
                            groupId,
                            subConditions[i],
                            currentPos,
                            doCondition,
                            elseCondition
                        );
                    }
                }
            }
            if (groupId) {
                this._groupLogicObj[groupId].conditionString = cString;
            }
        }
        return cString;
    }
    private _setGroupLogicObj(
        logicGroupId: string,
        condition: any,
        position: number,
        doCondition: any,
        elseCondition: any
    ): void {
        let dependentcyObgj = {
            positionList: [],
            do: null,
            else: null,
            conditionString: '',
            targetId: '',
        };
        if (this._groupLogicObj[logicGroupId]) {
            dependentcyObgj = this._groupLogicObj[logicGroupId];
        } else {
            this._groupLogicObj[logicGroupId] = dependentcyObgj;
        }
        dependentcyObgj.positionList = [
            ...(dependentcyObgj.positionList || []),
            { position, condition },
        ];
        if (!dependentcyObgj.do) {
            dependentcyObgj.do = doCondition;
        }
        if (!dependentcyObgj.else) {
            dependentcyObgj.else = elseCondition;
        }
        if (!dependentcyObgj.targetId) {
            dependentcyObgj.targetId = condition.target_id;
        }
    }
    private _getConditionOperator(condition: AndOrLogic): string {
        if (condition.and) {
            return '&&';
        } else if (condition.or) {
            return '||';
        } else {
            return '';
        }
    }
    private _getHiddenList(): string[] {
        return this._hiddenFieldsList.getValue();
    }
    private _setSurveyData = (surveyData: Survey): void => {
        this._surveyData = surveyData || null;
    };
    private _setSurveyHandledData = (
        handledDAta: SurveyHandledData[]
    ): void => {
        this._surveyHandledData = handledDAta || [];
    };
    private _setSurveyFormGroup = (formGroup: FormGroup): void => {
        this._surveyFormGroup = formGroup || null;
    };
    private _createFormControl = (
        item: BodyItem,
        groupFormName: string
    ): { [key: string]: FormControl } | null => {
        if (item.has_logic) {
            this.addToHiddenList(item.id);
        }
        if (item.type !== LAYOUT_ITEM_TYPE.descriptionQuestion) {
            return {
                [`${groupFormName}/${item.id}/${item.type}`]: new FormControl(
                    {
                        value: this._getInitialValue(item.type),
                        disabled: item.has_logic,
                    },
                    this.getPagePath() === APP_PATH.SURVEY_FORCE_EMBEDDED
                        ? []
                        : this._getValidators(item)
                ),
            };
        }
        return null;
    };
    private _getInitialValue = (type: string): boolean | string[] | string => {
        switch (type) {
            case LAYOUT_ITEM_TYPE.multiSelectVertical:
            case LAYOUT_ITEM_TYPE.multiSelectHorizon:
                return [] as string[];
            case LAYOUT_ITEM_TYPE.matrix:
                return null;
            case LAYOUT_ITEM_TYPE.termAndConditions:
                return false;
            default:
                return '';
        }
    };
    private _getValidators = (item: BodyItem): any[] => {
        if (item && item.validation) {
            const fieldValidator = item.validation;
            const validator = [];
            if (fieldValidator.regex) {
                validator.push(
                    Validators.pattern(new RegExp(fieldValidator.regex))
                );
            }
            const type = item.type || '';
            if (fieldValidator.required) {
                validator.push(
                    type === LAYOUT_ITEM_TYPE.termAndConditions
                        ? Validators.requiredTrue
                        : Validators.required
                );
            }
            if (fieldValidator.minSelect) {
                if (
                    type === LAYOUT_ITEM_TYPE.multiSelectVertical ||
                    type === LAYOUT_ITEM_TYPE.multiSelectHorizon ||
                    type === LAYOUT_ITEM_TYPE.tags ||
                    type === LAYOUT_ITEM_TYPE.multiSelectQuiz
                ) {
                    validator.push(
                        this._minSelectValidator(fieldValidator.minSelect)
                    );
                }
            }
            if (fieldValidator.maxSelect) {
                if (
                    type === LAYOUT_ITEM_TYPE.multiSelectVertical ||
                    type === LAYOUT_ITEM_TYPE.multiSelectHorizon ||
                    type === LAYOUT_ITEM_TYPE.tags ||
                    type === LAYOUT_ITEM_TYPE.multiSelectQuiz
                ) {
                    validator.push(
                        this._maxSelectValidator(fieldValidator.maxSelect)
                    );
                }
            }
            if (fieldValidator.minLength) {
                if (
                    type === LAYOUT_ITEM_TYPE.textAria ||
                    type === LAYOUT_ITEM_TYPE.inputText ||
                    type === LAYOUT_ITEM_TYPE.email ||
                    type === LAYOUT_ITEM_TYPE.phone
                ) {
                    validator.push(
                        Validators.minLength(fieldValidator.minLength)
                    );
                }
            }
            if (fieldValidator.maxLength) {
                if (
                    type === LAYOUT_ITEM_TYPE.textAria ||
                    type === LAYOUT_ITEM_TYPE.inputText ||
                    type === LAYOUT_ITEM_TYPE.email ||
                    type === LAYOUT_ITEM_TYPE.phone
                ) {
                    validator.push(
                        Validators.maxLength(fieldValidator.maxLength)
                    );
                }
            }
            return validator;
        }
        return [];
    };
    private _maxSelectValidator(num: number): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const size = control.value.length || 0;
            return size && size > num
                ? { maxSelect: { value: control.value } }
                : null;
        };
    }
    private _minSelectValidator(num: number): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const size = control.value.length || 0;
            return size < num ? { minSelect: { value: control.value } } : null;
        };
    }
}
